import { createFileRoute } from '@tanstack/react-router';
import { ComingSoon } from '@/features/placeholder/ComingSoon.tsx';

// Placeholder until this area is ported — see docs/features/*-barn-schedule.md.
export const Route = createFileRoute('/_app/barn-schedule')({
  component: BarnSchedulePage,
});

function BarnSchedulePage() {
  return <ComingSoon slug="barn-schedule" />;
}
